// export * from './home';
// export * from './auth.actions';
// export * from './tracking.actions';

import * as home from './home';
import * as auth from './auth.actions';
import * as tracking from './tracking.actions';
import * as users from './users.actions';

const actions = {
  ...home,
  ...auth,
  ...tracking,
  ...users,
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions/index.js